/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   vssf\client\webapi\httpclients\clientgeneratorconfigs\usermapping.genclient.json
 */

"use strict";

export enum UserType {
    Member = 1,
    Owner = 2
}

export var TypeInfo = {
    UserType: {
        enumValues: {
            "member": 1,
            "owner": 2
        }
    },
};
